module.exports = __webpack_public_path__ + "static/keyboardshortcut-result-dont-dc9edce044df6eb6a2dc4e824de9da71.png";